module.exports = __webpack_public_path__ + "static/afs-0329399cd015b3c24d05ba9e90b1f090.jpeg";